import React, {useEffect, useMemo, useState} from "react";
import t, {changeLanguage} from "../../components/I18N/TranslateHelpers";
import {GetCurrentLocale, groupBy, isTablet} from "../../components/Utils";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../app/RootReducer";
import { SpinnerOnTop } from "../../components/SpinnerOnTop";
import RadioFilter from "./FiltersType/RadioFilter";
import CheckboxFilter from "./FiltersType/CheckboxFilter";
import {allFiltersButton, applyFiltersButton, buttonDeleteFilters} from "../../components/UtilsForCart";
import {Filter} from "../Entity/Filter";
import { INDIVIDUAL_PROTECTION_CODE, SECURITE_BIEN_ETRE_CODE } from "../../app/AppConfig";
import { useNavigate } from "react-router-dom";

interface ComponentProps {
  resetFilters: () => void,
  filtersSelected: {index: string, values: string[]}[],
  setFiltersSelected: React.Dispatch<React.SetStateAction<{index: string, values: string[]}[]>>,
  pendingFilters: {index: string, values: string[]}[],
  setPendingFilters: React.Dispatch<React.SetStateAction<{index: string, values: string[]}[]>>,
  setGroupCode: React.Dispatch<React.SetStateAction<string>>,
  currentPage: number
  itemsPerPage: number
  groupCode: string
  taxonomiesSelected : string[]
  filtersSelectedParent: string
  filters: Filter[] | null,
  newViewProduct: string,
  isEndOfStock : boolean
}
const ProductsFilters: React.FC<ComponentProps> = ({resetFilters, filtersSelected,
                                                     setFiltersSelected, setGroupCode,
                                                     currentPage, itemsPerPage, groupCode,
                                                     taxonomiesSelected, filtersSelectedParent,
                                                     filters, newViewProduct,
                                                     pendingFilters, setPendingFilters,
                                                     isEndOfStock
}: ComponentProps) => {
  const locale = useMemo(() => GetCurrentLocale(), []);
  const dispatch = useDispatch();

  const taxonomiesProducts = filters && filters.filter((a: any) => a.parentCode !== INDIVIDUAL_PROTECTION_CODE &&
    a.parentCode !== SECURITE_BIEN_ETRE_CODE &&
    a.topParentCode !== INDIVIDUAL_PROTECTION_CODE &&
    a.topParentCode !== SECURITE_BIEN_ETRE_CODE
  );

  const taxonomiesGroupByParentCode = groupBy(taxonomiesProducts, 'groupLabel');
  const isRequesting = useSelector((state: RootState) => state.taxonRdc.isRequesting);
  let history = useNavigate();

  useEffect(() => {
    changeLanguage(locale);
  }, []);

  const [openFiltersOnMobile, setOpenFiltersOnMobile] = useState(false)

  const buttonApplyAndRemoveFilters = () => {
    return(
      <>
        {
          !isTablet ?

            applyFiltersButton(
              history,
              true,
              pendingFilters,
              setFiltersSelected,
              newViewProduct,
              isEndOfStock
          )
          :
            applyFiltersButton(
              history,
              true,
              pendingFilters,
              setFiltersSelected,
              newViewProduct,
              isEndOfStock,
              openFiltersOnMobile,
              setOpenFiltersOnMobile)

        }
        {
          // on affiche le boutton lorsqu'il n'y a pas de filtres/taxonomies sélectionné(e)s
          taxonomiesSelected.length !== 0 || filtersSelected.length !== 0 || filtersSelectedParent !== "" ?
            buttonDeleteFilters(resetFilters)
            :
            null
        }
      </>
    )
  }


  // useEffect(() => {
  //   const urlParams = GetUrlParams();
  //   const updatedFiltersArray = [];

  //   for (const key in urlParams) {
  //       if (urlParams.hasOwnProperty(key)) {
  //           const values = urlParams[key].split(';') && urlParams[key].split("%3B");
  //           updatedFiltersArray.push({ index: key, values });
  //       }
  //   }
  //   setFiltersSelected(updatedFiltersArray);
  // }, []);

  const allFilters = () => {
    return(
      <div id="aside_filter" className="card d-lg-block mb-5">
        {
          isRequesting ?
            <SpinnerOnTop/>
            :
            taxonomiesGroupByParentCode && Object.entries(taxonomiesGroupByParentCode).map((taxonItem: any, index) => {
                return (
                  <article className="filter-group" key={index + "-" + taxonItem[0]}>
                    <header className="card-header">
                      <a href="#" className="title collapsed" data-bs-toggle="collapse"
                         data-bs-target={"#" + taxonItem[0].replaceAll(' ', '-').toLowerCase()} aria-expanded="false">
                        <i className="control-icon-dropdown fa fa-chevron-down"/> {taxonItem[0]}
                      </a>
                    </header>
                    <div className="collapse" id={taxonItem[0].replaceAll(' ', '-').toLowerCase()}>
                      <div className="card-body">
                        {
                          taxonItem[1].sort((a: any, b: any) =>
                            (a.label && a.label.match(/^\d/)) ? parseInt(a.label) - parseInt(b.label) : (a.label ?? "").localeCompare(b.label ?? "")
                          ).map((subTaxonItem: any) => {
                            return (
                              <div key={index + "-" + subTaxonItem.code}>
                                {subTaxonItem.parentInputType === "radio" ? (
                                  <RadioFilter
                                    taxonItem={taxonItem}
                                    subTaxonItem={subTaxonItem}
                                    filtersSelected={filtersSelected}
                                    setFiltersSelected={setFiltersSelected}
                                    setGroupCode={setGroupCode}
                                    filtersSelectedParent={filtersSelectedParent}
                                  />
                                ) : (
                                  <CheckboxFilter
                                    subTaxonItem={subTaxonItem}
                                    pendingFilters={pendingFilters}
                                    setPendingFilters={setPendingFilters}
                                    isEndOfStock={isEndOfStock}
                                  />
                                )}
                              </div>
                            );
                          })

                        }
                      </div>
                    </div>
                  </article>
                )
              }
            )
        }
      </div>
    )
  }

  return (
    <>
      {
        !isTablet?
          allFilters()
          :
          /** popup of all filters on mobile **/
          <div className={openFiltersOnMobile ? "popup-filters-mobile active" : "popup-filters-mobile"}>
            <div className="col-md-12 d-flex justify-content-end mt-2 mb-2" onClick={() => setOpenFiltersOnMobile(!openFiltersOnMobile)}>
              <i className="fa-solid fa-times fontsize25 mr-5"></i>
            </div>
            {allFilters()}
          </div>
      }
      {
        !isTablet?
          buttonApplyAndRemoveFilters()
          :
          /** buttons fixed on mobile **/
        <div className="mobile-button-applyremove-filters">
          {allFiltersButton(openFiltersOnMobile, setOpenFiltersOnMobile)}
          {buttonApplyAndRemoveFilters()}
        </div>
      }
    </>
  );
}
export default ProductsFilters;


